export default __webpack_public_path__ + "static/media/bannerHTPMb.c7a4f832.png";